import { ViewFactory } from 'cube-react'

import AnaliseBulasScope from '../analise-bulas.scope'
import AnaliseBulasView from './v-analise-bulas'

export function registerViews(rr: typeof ViewFactory['register']) {
    rr(AnaliseBulasScope, AnaliseBulasView)
}